import snakeCase from 'lodash/snakeCase';
import type { IEventBridgeAdapter, GAEvent } from './types';

const EVENT_CATEGORY = 'gaEvent';

export class GAEventAdapter implements IEventBridgeAdapter<GAEvent> {
	formatEvent = (e: GAEvent) => {
		const originalEvent: typeof e = {
			type: `ga.${snakeCase(e.type)}`,
			details: e.details,
		};

		return {
			category: EVENT_CATEGORY,
			originalEvent,
			timestamp: new Date().toISOString(),
		};
	};
}
